// extracted by mini-css-extract-plugin
module.exports = {"MultiFinshProductBundleUI":"MultiFinshProductBundleUI_MultiFinshProductBundleUI__SU6zo"};